/**
 * Whether the event allows reschedule (solo, not adhoc, policy permits).
 * @param {Object} event - Meeting event
 * @returns {boolean}
 */
export const getShowReschedule = (event) => {
  if (!event) return false
  const isGroup = event.eventType?.kind === 'group'
  const isAdhoc = event.eventType?.type === 'AdhocEventType'
  return !(isGroup || isAdhoc) && Boolean(event.policy?.reschedule)
}
